type CsvRecord = Record<string, string>;

export async function readSpreadsheet(file: File): Promise<CsvRecord[]> {
  const json = await xlsxToJson(await file.arrayBuffer());

  return json;
}

async function xlsxToJson(buffer: ArrayBuffer) {
  const xlsx = await import('xlsx');

  const xlsxFile = xlsx.read(buffer, {
    cellDates: true, // Converts Excel dates (number) to JS dates (Date)
  });

  const [firstSheetName] = xlsxFile.SheetNames;
  const firstSheet = xlsxFile.Sheets[firstSheetName!];

  const fileContents = xlsx.utils
    .sheet_to_json(firstSheet!, {
      header: undefined, // Use the first row as header
      blankrows: false, // Ignore blank rows
    })
    .map((row) =>
      Object.entries(row as object).reduce<CsvRecord>((acc, [key, value]) => {
        if (value instanceof Date) {
          acc[key] =
            `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`;
        } else {
          acc[key] = value.toString().trim();
        }

        return acc;
      }, {})
    );

  return fileContents;
}
